// SEO.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, keywords, url }) => {
     const siteName = "HaveIdea";
     const defaultDesc =
          "HaveIdea is a platform to capture ideas, validate problems, and collaborate with builders to turn ideas into real products.";

     const finalTitle = title ? `${title} | ${siteName}` : siteName;
     const finalDesc = description || defaultDesc;

     return (
          <Helmet>
               <title>{finalTitle}</title>
               <meta name="description" content={finalDesc} />
               <meta name="keywords" content={keywords + 'haveidea' || "ideas, startup ideas, problem solving, collaboration, innovation"} />

               {/* Open Graph */}
               <meta property="og:title" content={finalTitle} />
               <meta property="og:description" content={finalDesc} />
               <meta property="og:type" content="website" />
               <meta property="og:url" content={url || window.location.href} />

               {/* Twitter */}
               <meta name="twitter:card" content="summary_large_image" />
               <meta name="twitter:title" content={finalTitle} />
               <meta name="twitter:description" content={finalDesc} />
          </Helmet>
     );
};

export default SEO;



export const seoConfig = {
     home: {
          title: "Turn Ideas into Reality",
          description: "Capture, validate, and build ideas with HaveIdea. A platform for creators and builders.",
          keywords: "startup ideas, idea validation, build ideas"
     },

     login: {
          title: "Login",
          description: "Login to HaveIdea and continue building your ideas.",
          keywords: "login, haveidea login"
     },

     register: {
          title: "Register",
          description: "Create your HaveIdea account and start sharing ideas.",
          keywords: "register, signup, create account"
     },

     verify: {
          title: "Verify Account",
          description: "Verify your account to unlock full access.",
          keywords: "verify email, account verification"
     },

     overview: {
          title: "Overview",
          description: "Manage your ideas, collaborations and activity.",
          keywords: "dashboard, overview, ideas management"
     },

     privacy: {
          title: "Privacy Policy",
          description: "Learn how we protect your data and privacy.",
          keywords: "privacy policy, data protection"
     },

     terms: {
          title: "Terms & Conditions",
          description: "Read the terms and conditions of using HaveIdea.",
          keywords: "terms, conditions, policy"
     },

     about: {
          title: "About HaveIdea",
          description: "Learn about the mission and vision of HaveIdea.",
          keywords: "about haveidea, mission, vision"
     },

     explore: {
          title: "Explore Ideas",
          description: "Discover real-world problems and ideas shared by users.",
          keywords: "explore ideas, startup problems"
     },

     interested: {
          title: "Idea Details",
          description: "View full details of the idea and engage with it.",
          keywords: "idea details, problem details"
     },

     submit: {
          title: "Submit Idea",
          description: "Share your idea with the community and get feedback.",
          keywords: "submit idea, post idea"
     },

     features: {
          title: "Features",
          description: "Explore all features of HaveIdea platform.",
          keywords: "features, platform features"
     }
};
